import { z } from 'zod';

import { zodSuccessResponseSchema } from '../validations';

export const zodBulkBillDlnItemsItemSchema = z.object({
  billedQuantityFactor: z.number().min(0).max(1),
  itemId: z.number().int().min(0),
});

export const zodBulkBillDlnItemsBodySchema = z.object({
  items: z.array(zodBulkBillDlnItemsItemSchema),
});

export const zodBulkBillDlnItemsEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('item'),
  z.literal('bulk'),
  z.literal('bill'),
]);

export { zodSuccessResponseSchema };
